var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveBage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 1900 200",
    width: 1900,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 77L17.7 74C35.3 71 70.7 65 105.8 64.7C141 64.3 176 69.7 211.2 76.7C246.3 83.7 281.7 92.3 316.8 94.8C352 97.3 387 93.7 422.2 100C457.3 106.3 492.7 122.7 527.8 119.2C563 115.7 598 92.3 633.2 81.8C668.3 71.3 703.7 73.7 738.8 87C774 100.3 809 124.7 844.2 135.8C879.3 147 914.7 145 950 137.3C985.3 129.7 1020.7 116.3 1055.8 105.2C1091 94 1126 85 1161.2 84.5C1196.3 84 1231.7 92 1266.8 90C1302 88 1337 76 1372.2 79.3C1407.3 82.7 1442.7 101.3 1477.8 108.7C1513 116 1548 112 1583.2 103.3C1618.3 94.7 1653.7 81.3 1688.8 80.8C1724 80.3 1759 92.7 1794.2 100.8C1829.3 109 1864.7 113 1882.3 115L1900 117L1900 201L1882.3 201C1864.7 201 1829.3 201 1794.2 201C1759 201 1724 201 1688.8 201C1653.7 201 1618.3 201 1583.2 201C1548 201 1513 201 1477.8 201C1442.7 201 1407.3 201 1372.2 201C1337 201 1302 201 1266.8 201C1231.7 201 1196.3 201 1161.2 201C1126 201 1091 201 1055.8 201C1020.7 201 985.3 201 950 201C914.7 201 879.3 201 844.2 201C809 201 774 201 738.8 201C703.7 201 668.3 201 633.2 201C598 201 563 201 527.8 201C492.7 201 457.3 201 422.2 201C387 201 352 201 316.8 201C281.7 201 246.3 201 211.2 201C176 201 141 201 105.8 201C70.7 201 35.3 201 17.7 201L0 201Z",
    fill: "#ece7db",
    strokeLinecap: "round",
    strokeLinejoin: "miter"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveBage);
export default __webpack_public_path__ + "static/media/wave-bage.94f7135d3fdd55b7068c0d592c99935b.svg";
export { ForwardRef as ReactComponent };